import PublisherDetail from "./PublisherDetail";
export default PublisherDetail;
